(function () {
    'use strict';
    var m = angular.module('profiles');
    m.factory('checkpointTeScanDetailsLogic', ["$q", "fileScanDetailsLogicCore", "configDao", "cpUiFunctions", "feature", "fileDao", "widgetPolling", "metaInfoLogicCore", "modals", "vkbeautify", "brandInfo", function ($q, fileScanDetailsLogicCore, configDao, cpUiFunctions, feature, fileDao, widgetPolling, metaInfoLogicCore, modals, vkbeautify, brandInfo) {
        return function ($scope, logic) {
            var id = logic.entityId || widgetPolling.scope().id;
            var pdfButton = $scope.model.wrapper.buttons && $scope.model.wrapper.buttons[0] || {
                'class': 'btn-blue',
                label: 'View full PDF report',
                hidden: true,
                position: 'right'
            };
            $scope.model.wrapper.buttons = [pdfButton];
            $scope.coreOptionButtons = $scope.coreOptionButtons || [];
            function setButtons(xmlReport, pdfReportImages, _summary_report) {
                var xmlButtonIdx = _(coreOptions.buttons).findIndex(function (button) {
                    return button.id === 'view-xml-report-button';
                });
                if (xmlReport) {
                    var xmlStr = vkbeautify.xml(xmlReport);
                    var xmlButton;
                    if (xmlStr.indexOf('<reports></reports>') === -1) {
                        xmlButton = {
                            id: 'view-xml-report-button',
                            label: 'View XML report',
                            'class': 'download-xml-button',
                            onClick: function () {
                                modals.htmlXmlViewer(vkbeautify.xml(xmlReport), {
                                    title: 'View XML Report',
                                    editable: false,
                                    btnSelectAll: true,
                                    labelSelectAll: 'Select All'
                                });
                            }
                        };
                    } else {
                        if (!_summary_report && Object.keys(pdfReportImages).length === 0) {
                            xmlButton = {
                                id: 'view-xml-report-button',
                                label: 'XML emulation report for this file is currently not available',
                                'class': 'download-xml-unavailable',
                                onClick: _.noop()
                            };
                        } else {
                            xmlButton = {};
                        }
                    }
                    if (xmlButtonIdx !== -1) {
                        coreOptions.buttons[xmlButtonIdx] = xmlButton;
                    } else {
                        coreOptions.buttons.push(xmlButton);
                    }
                } else {
                    if (xmlButtonIdx !== -1) {
                        coreOptions.splice(xmlButtonIdx, 1);
                    }
                }
                if (cpUiFunctions.isCpCustomer()) {
                    // button for HTML report download
                    if (_summary_report) {
                        pdfButton.hidden = false;
                        pdfButton.label = 'View report';
                        pdfButton.onclick = function () {
                            var api = '/api/v1/checkpoint/summary_report/' + logic.entityType + '/' + id + '/' + _summary_report + '/ThreatEmulationReport.html';
                            var encodedUrl = cpUiFunctions.createCPLoadPageUrl(brandInfo.getPortalUrl('cp'), api);
                            window.open(encodedUrl);
                        };    // button for pdf report download
                    } else {
                        var options = _(pdfReportImages).chain().keys().map(function (imageId) {
                            return {
                                imageId: imageId,
                                label: pdfReportImages[imageId],
                                onclick: function () {
                                    var api = '/api/v1/checkpoint/pdf_report/' + logic.entityType + '/' + id + '/' + imageId;
                                    var encodedUrl = cpUiFunctions.createCPLoadPageUrl(brandInfo.getPortalUrl('cp'), api);
                                    window.open(encodedUrl);
                                }
                            };
                        }).value();
                        if (options.length > 0) {
                            pdfButton.options = options;
                            pdfButton.hidden = false;
                        } else {
                            pdfButton.hidden = true;
                        }
                    }
                } else {
                    // button for HTML report download
                    if (_summary_report) {
                        pdfButton.hidden = false;
                        pdfButton.label = 'View report';
                        pdfButton.onclick = function () {
                            window.open('/api/v1/checkpoint/summary_report/' + logic.entityType + '/' + id + '/' + _summary_report + '/ThreatEmulationReport.html');
                        };    // button for pdf report download
                    } else {
                        var options1 = _(pdfReportImages).chain().keys().map(function (imageId) {
                            return {
                                imageId: imageId,
                                label: pdfReportImages[imageId],
                                onclick: function () {
                                    window.open('/api/v1/checkpoint/pdf_report/' + logic.entityType + '/' + id + '/' + imageId);
                                }
                            };
                        }).value();
                        if (options1.length > 0) {
                            pdfButton.options = options1;
                            pdfButton.hidden = false;
                        } else {
                            pdfButton.hidden = true;
                        }
                    }
                }
            }
            var coreOptions = {
                retrieve: function () {
                    return fileDao.checkpointTeScanDetails(id, logic.entityType).converter(function (input, args) {
                        var summary_report = input.data.raw_res && input.data.raw_res.te && input.data.raw_res.te.summary_report;
                        setButtons(input.data.xml_report, args.pdfReportImages.data.images, summary_report);
                        delete input.data.xml_report;
                        return $q.when(input);
                    }, function (preFetches) {
                        return { pdfReportImages: preFetches.pdfReportImages };
                    });
                },
                advanced: logic.advanced,
                whiteList: logic.whiteList,
                blackList: logic.blackList || [],
                coreLogic: metaInfoLogicCore,
                moduleLabels: logic.moduleLabels,
                autoByEntityInfo: logic.autoByEntityInfo,
                ordering: 'entityOrder',
                buttons: $scope.coreOptionButtons
            };
            return fileScanDetailsLogicCore($scope, logic, coreOptions);
        };
    }]);
}());